module.exports = __webpack_public_path__ + "static/img/product-20.03bbcc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-20.png
// module id = f6/4
// module chunks = 0